export default function mounted() {
	this.getJournalTypes();
	/** Get Account Heads **/
    this.getLedgerHeads();
	/** Get Account Heads **/
    this.getAccountHeads();
}
